import FastLane from "./FastLane/FastLane";
import FastLaneTickers from "./FastLaneTickers/FastLaneTickers";

export default {
  FastLane: FastLane,
  FastLaneTickers: FastLaneTickers
}